import { render, staticRenderFns } from "./ShipmentWiseProfitLossReport.vue?vue&type=template&id=58176f16&"
import script from "./ShipmentWiseProfitLossReport.vue?vue&type=script&lang=js&"
export * from "./ShipmentWiseProfitLossReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports